import { Component, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DialogRef } from '../modal/dialog-ref';
import { DIALOG_DATA } from '../modal/dialog-tokens';
import { CoreLibModalComponent } from '../modal/modal.component';
import { UtilService } from 'app/shared/util.service';

@Component({
    selector: 'mh-complete-profile-modal',
    templateUrl: './complete-profile-modal.component.html',
    styleUrls: ['./complete-profile-modal.component.scss'],
    standalone: false
})
export class CompleteProfileModalComponent extends CoreLibModalComponent implements OnInit {
  username: string;
  percentage: number;

  constructor(
    protected dialogRef: DialogRef,
    @Inject(DIALOG_DATA) public data: any,
    private router: Router,
    private utilService: UtilService,
  ) {
    super(dialogRef, data);
  }

  ngOnInit(): void {
    this.username = this.data?.username || this.utilService.getCurrentUser()?.name || 'Usuario';
    this.percentage = this.data?.percentage || 0;
  }

  handleSkip() {
    localStorage.removeItem('shouldShowProfileCompletionModal');
    this.close({ action: 'skip' });
  }

  handleComplete() {
    localStorage.removeItem('shouldShowProfileCompletionModal');
    this.close({ action: 'complete' });
    this.router.navigate(['/perfil']);
  }
}
